export const SignedMatchmakerABI = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "engine",
        "type": "address",
        "internalType": "contract IEngine"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "ENGINE",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "contract IEngine"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "eip712Domain",
    "inputs": [],
    "outputs": [
      {
        "name": "fields",
        "type": "bytes1",
        "internalType": "bytes1"
      },
      {
        "name": "name",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "version",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "chainId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "verifyingContract",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "salt",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "extensions",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "hashTypedData",
    "inputs": [
      {
        "name": "structHash",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "openBattleOfferNonce",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "startGame",
    "inputs": [
      {
        "name": "offer",
        "type": "tuple",
        "internalType": "struct BattleOffer",
        "components": [
          {
            "name": "battle",
            "type": "tuple",
            "internalType": "struct Battle",
            "components": [
              {
                "name": "p0",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "p0TeamIndex",
                "type": "uint96",
                "internalType": "uint96"
              },
              {
                "name": "p1",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "p1TeamIndex",
                "type": "uint96",
                "internalType": "uint96"
              },
              {
                "name": "p2",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "p2TeamIndex",
                "type": "uint96",
                "internalType": "uint96"
              },
              {
                "name": "p3",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "p3TeamIndex",
                "type": "uint96",
                "internalType": "uint96"
              },
              {
                "name": "teamRegistry",
                "type": "address",
                "internalType": "contract ITeamRegistry"
              },
              {
                "name": "rngOracle",
                "type": "address",
                "internalType": "contract IRandomnessOracle"
              },
              {
                "name": "ruleset",
                "type": "address",
                "internalType": "contract IRuleset"
              },
              {
                "name": "moveManager",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "matchmaker",
                "type": "address",
                "internalType": "contract IMatchmaker"
              },
              {
                "name": "engineHooks",
                "type": "address[]",
                "internalType": "contract IEngineHook[]"
              }
            ]
          },
          {
            "name": "pairHashNonce",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "battleMode",
            "type": "uint8",
            "internalType": "uint8"
          }
        ]
      },
      {
        "name": "openSeatsMask",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "seatSigs",
        "type": "bytes[4]",
        "internalType": "bytes[4]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "startGameWithSeatConfigs",
    "inputs": [
      {
        "name": "offer",
        "type": "tuple",
        "internalType": "struct BattleOffer",
        "components": [
          {
            "name": "battle",
            "type": "tuple",
            "internalType": "struct Battle",
            "components": [
              {
                "name": "p0",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "p0TeamIndex",
                "type": "uint96",
                "internalType": "uint96"
              },
              {
                "name": "p1",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "p1TeamIndex",
                "type": "uint96",
                "internalType": "uint96"
              },
              {
                "name": "p2",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "p2TeamIndex",
                "type": "uint96",
                "internalType": "uint96"
              },
              {
                "name": "p3",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "p3TeamIndex",
                "type": "uint96",
                "internalType": "uint96"
              },
              {
                "name": "teamRegistry",
                "type": "address",
                "internalType": "contract ITeamRegistry"
              },
              {
                "name": "rngOracle",
                "type": "address",
                "internalType": "contract IRandomnessOracle"
              },
              {
                "name": "ruleset",
                "type": "address",
                "internalType": "contract IRuleset"
              },
              {
                "name": "moveManager",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "matchmaker",
                "type": "address",
                "internalType": "contract IMatchmaker"
              },
              {
                "name": "engineHooks",
                "type": "address[]",
                "internalType": "contract IEngineHook[]"
              }
            ]
          },
          {
            "name": "pairHashNonce",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "battleMode",
            "type": "uint8",
            "internalType": "uint8"
          }
        ]
      },
      {
        "name": "openSeatsMask",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "seatSigs",
        "type": "bytes[4]",
        "internalType": "bytes[4]"
      },
      {
        "name": "seatConfigs",
        "type": "tuple[3]",
        "internalType": "struct SeatPhantomConfig[3]",
        "components": [
          {
            "name": "monIndices",
            "type": "uint256[]",
            "internalType": "uint256[]"
          },
          {
            "name": "facetIds",
            "type": "uint8[]",
            "internalType": "uint8[]"
          },
          {
            "name": "moveSelections",
            "type": "uint8[]",
            "internalType": "uint8[]"
          }
        ]
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "error",
    "name": "CreatorSeatCannotBeOpen",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidNonce",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidOpenBattleOfferNonce",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidOpenSeatsMask",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidSignature",
    "inputs": []
  },
  {
    "type": "error",
    "name": "MissingConsent",
    "inputs": []
  }
] as const;
